import { Routes } from '@angular/router';

import { entityUpsertPermissionGuard } from '@guards/entity-permission.guard';

import { ALL_PERMISSIONS } from '@models/permission.model';

/**
 * FEC-1160 QA (18 Aug): "Agencies permission for the master agent is not
 * working at all." The Agencies rows on the permissions matrix wrote to the
 * database but nothing read them — these routes were ungated. Editing an agency
 * now needs UPDATE_AGENCY and creating one needs CREATE_AGENCY.
 *
 * `/agency` is the agency manager's own-agency screen, which is governed by
 * UPDATE_OWN_AGENCY rather than the platform-wide agency capability.
 */
export const AGENCY_ROUTES: Routes = [
  {
    path: 'agency',
    loadComponent: () =>
      import('@pages/agency/agency-upsert/agency-upsert.component').then(
        (c) => c.AgencyUpsertComponent,
      ),
    data: { layout: 'private' },
    canActivate: [
      entityUpsertPermissionGuard(
        ALL_PERMISSIONS.UPDATE_OWN_AGENCY,
        ALL_PERMISSIONS.UPDATE_OWN_AGENCY,
      ),
    ],
  },
  {
    path: 'agencies-dev',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/agency/agency-directory/agency-directory.component').then(
            (c) => c.AgencyDirectoryComponent,
          ),
        data: { layout: 'private' },
      },
      {
        path: ':id',
        loadComponent: () =>
          import('@pages/agency/agency-upsert/agency-upsert.component').then(
            (c) => c.AgencyUpsertComponent,
          ),
        data: { layout: 'private' },
        canActivate: [
          entityUpsertPermissionGuard(ALL_PERMISSIONS.CREATE_AGENCY, ALL_PERMISSIONS.UPDATE_AGENCY),
        ],
      },
    ],
  },
];
